<template>
  <div :key="$i18n.locale" class="flex flex-wrap">
    <div class="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <template :key="key" v-for="(service, key) in goldenServices">
        <GoldenServiceCard :serviceId="service.serviceId" category="golden-residency">
          <p class="text-center">{{ $t(service.t9nKey) }}</p>
        </GoldenServiceCard>
      </template>
    </div>
  </div>
</template>

<script setup>
import GoldenServiceCard from '@/components/cards/GoldenServiceCard.vue'

const goldenServices = [
  { serviceId: 603, t9nKey: 'sixMonthsToFinalizeProceduresForGoldenResidency' },
  { serviceId: 767, t9nKey: 'service_767' },
  { serviceId: 977, t9nKey: 'service_977' },
  { serviceId: 753, t9nKey: 'service_753' },
  { serviceId: 636, t9nKey: 'service_636' },
  { serviceId: 632, t9nKey: 'service_632' },
  { serviceId: 633, t9nKey: 'service_633' },
  { serviceId: 634, t9nKey: 'service_634' },
  { serviceId: 635, t9nKey: 'service_635' },
  { serviceId: 978, t9nKey: 'service_978' },
  { serviceId: 1104, t9nKey: 'service_1104' },
  { serviceId: 1105, t9nKey: 'service_1105' }
]
</script>

<style lang="scss" scoped></style>
